import { h } from 'preact';
import useResponsive from 'utils/responsive';
import Image from 'utils/image';

const CollectionBanner = ({ collection }) => {
  const {
    title,
    description,
    textColor,
    textAlignDesktop,
    textAlignMobile,
    bgOverlay,
    image: { src: imageSrc, imageAlt, width, height },
    mobileImage: { src: mobileImageSrc, mobileAlt, mobileWidth, mobileHeight },
  } = collection;

  const textColorStyle = textColor && textColor !== "rgba(0,0,0,0)" ? { color: textColor } : {};
  const { isMobile } = useResponsive();

  const imageSizes = !mobileImageSrc
    ? { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }
    : { lg: 1024, xl: 1280, '2xl': 1536 };

  return (
    <div
      className={`container--full relative flex flex-col gap-12 overflow-hidden`}
    >
      {mobileImageSrc && isMobile && (
        <Image
          src={mobileImageSrc}
          alt={mobileAlt}
          srcWidths={{ sm: 640, md: 768 }}
          classes="w-full h-full absolute image object-cover sm:object-center object-center"
          width={mobileWidth}
          height={mobileHeight}
          loading="eager"
        />
      )}
      {imageSrc && !isMobile && (
        <Image
          src={imageSrc}
          alt={imageAlt}
          srcWidths={imageSizes}
          classes="w-full h-full absolute image object-cover sm:object-center object-center"
          width={width}
          height={height}
          loading="eager"
        />
      )}

      <div 
        className={`
          relative container-full left-0 top-0 w-full h-full z-1 
          ${ imageSrc ? "md:py-64" : "md:py-40" } 
          ${ mobileImageSrc ? "py-40" : "py-25" } 
          ${ bgOverlay ? "bg-black bg-opacity-25" : "" }`}
      >
        <div className={`
          relative container px-25 flex flex-col h-full justify-center 
          ${textAlignDesktop} ${textAlignMobile}`}
        >
          <h2
            className={`h2 z-1 ${
                textColor && textColor !== "rgba(0,0,0,0)" 
                ? '' 
                : mobileImageSrc 
                  ? 'text-white' 
                  : 'text-faded-black'
              } ${
                textColor && textColor !== "rgba(0,0,0,0)" 
                ? ''
                : imageSrc 
                  ? 'md:text-white' 
                  : 'md:text-faded-black'
              }`}
              style={textColorStyle}
            dangerouslySetInnerHTML={{ __html: title }}
          ></h2>
          {description && (
            <div
              className={`rte z-1 mt-10 md:mt-15 ${
                textColor && textColor !== "rgba(0,0,0,0)" 
                  ? '' 
                  : mobileImageSrc 
                    ? 'text-white' 
                    : 'text-faded-black'
              } ${
                textColor && textColor !== "rgba(0,0,0,0)" 
                ? ''
                : imageSrc 
                  ? 'md:text-white' 
                  : 'md:text-faded-black'}`}
              dangerouslySetInnerHTML={{ __html: description }}
              style={textColorStyle}
            ></div>
          )}
        </div>
      </div>
      
    </div>
  );
};

export default CollectionBanner;
